import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lang: "AZ",
  },
  mutations: {
    SET_LANG(state, lang) {
      state.lang = lang;
    },
  },
  actions: {
    setLang({ commit }, lang) {
      commit("SET_LANG", lang);
    },
  },
  getters: {
    langindex: (state) => {
      if (state.lang === "AZ") return 0;
      else if (state.lang === "EN") return 1;
      else return 0;
    },
  },
});
